import type { GetSubscriptionRenewPlansResponse, RenewPlan } from './types';
import type {
  GetProductDataResponseV2,
  Plan,
} from 'services/repositories/products/getProductDataV2';

const mapRenewPlanToPlan = (renewPlan: RenewPlan): Plan & { id: string } => ({
  id: renewPlan.id,
  amount: renewPlan.amount,
  amountTax: 0,
  standardAmount: renewPlan.standardAmount,
  standardTax: 0,
  amountMonthly: 0,
  amountMonthlyTax: 0,
  code: renewPlan.code,
  planName: renewPlan.name,
  planType: renewPlan.type,
  currency: renewPlan.currency,
  installments: renewPlan.installments.map((installment) => ({
    id: installment.id,
    value: installment.value,
    standardValue: installment.standardValue,
    tax: installment.tax,
    totalValue: installment.totalValue,
    amount: installment.amount,
  })),
  paymentMethods: (renewPlan.paymentMethods ?? []).map((method) => ({
    type: method,
  })),
  allowCombinedPaymentMethods: renewPlan.allowCombinedPaymentMethods ?? false,
});

export const transformRenewPlansToProductData = (
  renewPlansResponse: GetSubscriptionRenewPlansResponse
): GetProductDataResponseV2 => ({
  name: renewPlansResponse.productName,
  code: renewPlansResponse.productCode,
  source: undefined,
  seller: undefined,
  checkTicketQuantityAvailable: false,
  plans: renewPlansResponse.plans.map(mapRenewPlanToPlan),
});
